<template>
  <v-flex xs12>
    <v-card elevation="15">
      <v-card-title primary-title class="h3">
        Leveransreklamation per utb
      </v-card-title>       
      <v-card-subtitle>
        <v-row>
          <v-col cols="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="dates"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-card>
                <v-card-text>
                  <div>            
                    <v-btn small text @click="setDates('last7days')">
                      Last 7 days
                    </v-btn>
                    <v-btn small text @click="setDates('thismonth')">
                      This month
                    </v-btn>
                    <v-btn small text @click="setDates('lastmonth')">
                      Last month
                    </v-btn>
                  </div>
                </v-card-text>   
                <v-date-picker v-model="dates" no-title scrollable range 
                               :first-day-of-week="1"
                               locale="sv-SE"
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="resetDates()">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="saveDates()">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-card>
            </v-menu>
          </v-col>
          <v-spacer />
          <v-col cols="9">
            <v-row>
              <v-col cols="6">
                <v-menu
                  ref="filterMenu"
                  v-model="filterMenu"
                  :close-on-content-click="false"
                  :return-value.sync="filteredDates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="filteredDates"
                      multiple
                      outlined
                      small-chips            
                      label="Filtrera bort datum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:selection="{ attribs, item, parent, selected }">
                        <v-chip
                          v-bind="attribs"         
                          :input-value="selected"          
                          small
                        >
                          <span class="pr-2 chip">
                            {{ item }}
                          </span>          
                        </v-chip>
                      </template>
                    </v-combobox>
                  </template>
                  <v-date-picker
                    v-model="filteredDates"
                    multiple
                    no-title
                    scrollable
                    :first-day-of-week="1"
                    locale="sv-SE"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="filterMenu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.filterMenu.save(filteredDates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
       
              <v-col cols="6">
                <v-combobox
                  v-model="filteredUtb"
                  :items="distributors"
                  label="Utb:er"
                  multiple
                  outlined
                  item-value="distributor.name"
                  item-text="distributor.name"              
                  :return-object="false"
                />
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="filteredPaper"
                  :items="paperEditions"
                  label="Utgåvor"
                  multiple
                  outlined           
                  small     
                  item-text="name"
                  :return-object="true" 
                  class="overflow-hidden"                 
                >
                  <template v-slot:item="{ attrs, item }">
                    <v-label v-if="item.titleId === 1">
                      {{ item.title }}
                    </v-label>
                    <v-label v-else>
                      {{ item.name }}
                    </v-label>
                  </template>
                  <template v-slot:selection="{ attrs, item }">          
                    <v-chip small>
                      <span v-if="item.titleId === 1" class="text-caption">
                        {{ item.title }}
                      </span>
                      <span v-else class="text-caption">
                        {{ item.name }}
                      </span>
                    </v-chip>                                  
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-subtitle>

      <v-container v-if="loading">
        <v-overlay>
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Hämtar data...
            </v-col>
            <v-col cols="12">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-overlay>
      </v-container>
      <v-container v-else>
        <v-list>
          <v-list-group v-for="(dist, k) in distributersFilterdByDate" :key="k">
            <template v-slot:activator>
              <v-list-item-title>
                <v-row>
                  <v-col cols="3">
                    {{ dist.distributor.name }}
                  </v-col>
                  <v-col cols="4">
                    Antal rapporterande kunder:
                    {{ dist.customers.length }} ({{
                      ((dist.customers.length /
                        dist.distributor.customerCount) *
                        100)
                        | toFixed(2)
                    }}
                    %)
                  </v-col>
                  <v-col cols="1">
                    {{ sum(dist.customers, "amount") }}
                  </v-col>
                  <v-col cols="2" class="text-right">
                    {{ sumPrice(dist.customers) | toSek() | toFixed(2) }} kr.
                  </v-col>
                  <v-col>
                    <v-btn primary @click.stop="exportExcel(dist)">
                      Excel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </template>
            <v-list-item-title class="v-list-group-header pl-12">
              <v-row class="pl-6">
                <v-col cols="1">
                  Id
                </v-col>
                <v-col cols="3">
                  Namn
                </v-col>
                <v-col cols="1" class="pl-0">
                  Postkod
                </v-col>
                <v-col cols="2" class="pl-0"> 
                  Stad
                </v-col>
                <v-col cols="1" class="pl-0">
                  Antal
                </v-col>
                <v-col cols="1" class="text-center pl-2">
                  Summa
                </v-col>
              </v-row>
            </v-list-item-title>
            <v-list-group
              v-for="(customer, j) in dist.customers"
              :key="j"
              sub-group
              prepand-icon
              class="p-0 m-0"
              :class="[hasZero(customer)?'zero':'']"
            >
              <template v-slot:activator>
                <v-list-item-title>
                  <v-row>
                    <v-col cols="1">
                      {{ customer.id }}
                    </v-col>
                    <v-col cols="3">
                      <v-badge inline left
                               color="secondary"
                               title="Återkommande rapportör, antal dagar av senaste 30 dagarna."
                               :content="customer.frequency"
                      >
                        {{ customer.name }}
                      </v-badge>
                    </v-col>
                    <v-col cols="1">
                      {{ customer.zipCode }}
                    </v-col>
                    <v-col cols="2">
                      {{ customer.city }}
                    </v-col>
                    <v-col cols="1">
                      {{ customer.amount }}
                    </v-col>
                    <v-col cols="1" class="text-right">
                      {{ price(customer.papers) | toSek() | toFixed(2) }} kr.
                    </v-col>                                       
                  </v-row>
                </v-list-item-title>
              </template>
              <v-list-item>
                <v-list-item-title class="p-0 m-0">
                  <v-row>
                    <v-col cols="3" offset="1">
                      Tidning
                    </v-col>
                    <v-col>Datum</v-col>
                    <v-col>Följesedel</v-col>
                    <v-col>Mottagit</v-col>                    
                  </v-row>
                </v-list-item-title>
              </v-list-item>
              <v-divider class="ma-0" />
              <v-list-item
                v-for="(paper,ind) in customer.papers"
                :key="ind"
                class="p-0 m-0 paper"
              >
                <v-list-item-content class="pa-0 m-0">
                  <v-list-item-title>
                    <v-row>
                      <v-col cols="3" offset="1">
                        {{ paper.name }}
                      </v-col>
                      <v-col>{{ paper.deliveryDate|toLocalDate() }} </v-col>
                      <v-col>{{ paper.deliveredAmount }} </v-col>
                      <v-col>{{ paper.receivedAmount }}</v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </v-list>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
import api from '@/backend/api'
import { reduce,cloneDeep } from 'lodash'
import moment from 'moment'
import { saveExcel } from '@progress/kendo-vue-excel-export'
import { process } from '@progress/kendo-data-query'

// const CustomGroupHeader = (props) =>  (
//    `${props.value}  -  Totalt : ${props.aggregates.amount.sum}st ${props.aggregates.totalPrice.sum.toFixed(2)}kr`
//   )

export default {
  name: 'Distribution',
  data() {
    return {
      list: [],
      dates: ['2022-08-07', '2022-08-07'],
      filteredDates:[],
      filteredUtb:[],
      filteredPaper:[],
      paperEditions:[],
      oldDates: [],
      loading: true,
      menu: false,     
      filterMenu:false,
      timer:'',
      group: [ { field: 'name', aggregates: this.aggregates } ] ,    
      aggregates: [
                { field: 'amount', aggregate: 'sum' }, 
                { field: 'totalPrice', aggregate: 'sum' }               

            ], 
    }
  },
  computed: {
    distributors() {
      return this.list
    },
    dateRangeText() {
      return this.dates.join(' - ')
    },       
    distributersFilterdByDate(){
      let tmpDist = cloneDeep(this.list)

      if(this.filteredUtb.length > 0 && this.filteredDates.length === 0){
        tmpDist = tmpDist.filter(p=>  this.filteredUtb.indexOf(p.distributor.name) < 0)        
      }else if(this.filteredDates.length > 0){      
       // let filterDate = new Date('2023-04-24')
        let self = this
        //Utb men inte utgåva.
        if(self.filteredUtb.length > 0 && self.filteredPaper.length === 0){
          tmpDist.filter(p=> this.filteredUtb.indexOf(p.distributor.name) > -1).forEach(dist=>{                       
            dist.customers = dist.customers.filter(function(cust){
                cust.papers = self.$options.filters.filterOutPaperByDeliveryDate(cust.papers, self.filteredDates)                
                return cust.papers.length > 0
              })
            })
        }else if(self.filteredUtb.length > 0 && self.filteredPaper.length > 0){
          //Utb och utåva och datum
          tmpDist.filter(p=> this.filteredUtb.indexOf(p.distributor.name) > -1).forEach(dist=>{                       
            dist.customers = dist.customers.filter(function(cust){
                cust.papers = self.$options.filters.filterOutPaperByTitleEditionIdAndDeliveryDate(cust.papers, self.filteredPaper.map(function(o){return o.id.substring(0,o.id.lastIndexOf(':')) }), self.filteredDates)                
                return cust.papers.length > 0
              })
            })        
        }else if((self.filteredUtb.length === 0 && self.filteredPaper.length > 0)){
          //Datum och utgåva
            tmpDist.forEach(dist=>{                       
              dist.customers = dist.customers.filter(function(cust){
                cust.papers = self.$options.filters.filterOutPaperByTitleEditionIdAndDeliveryDate(cust.papers, self.filteredPaper.map(function(o){return o.id.substring(0,o.id.lastIndexOf(':')) }), self.filteredDates)
                return cust.papers.length > 0
              })
            })
         }else{
          //Bara datum
            tmpDist.forEach(dist=>{                       
              dist.customers = dist.customers.filter(function(cust){
                cust.papers = self.$options.filters.filterOutPaperByDeliveryDate(cust.papers, self.filteredDates)
                return cust.papers.length > 0
              })
            })
         }
      }
      
      return tmpDist.filter(dist=> dist.customers.length > 0)
    }
  },

  
  mounted() {
    if (this.group) {
            this.group.map(group => group.aggregates = this.aggregates)
        }
    this.setDates('today')
    this.loadData()
    this.timer = setInterval(this.loadData, 300000)
  },
  destroyed(){
    this.cancelAutoUpdate()
  },
  methods: {
    hasZero(customer)
    {
      var zero = false
      for(var i = 0;i<customer.papers.length; i++){
        if(customer.papers[i].receivedAmount === 0 ){
          zero = true
          break
        }
      }
      return zero
    },
    setDates(period){
      var todayDate = new Date()
      this.oldDates = [...this.dates]
      var newDates = [2]
      if(period === 'today'){        
        newDates[0] = todayDate.toISOString().slice(0, 10)
        newDates[1] = todayDate.toISOString().slice(0, 10)      
        this.updateDates(newDates)
      }
      if(period === 'last7days'){
        newDates[0] = this.addDays(todayDate,-7).toISOString().slice(0, 10)
        newDates[1] = todayDate.toISOString().slice(0, 10)
        this.updateDates(newDates)
      }
      else if(period === 'lastmonth')
       {
        const d = moment(todayDate).subtract(1, 'months')
        newDates[0] = d.startOf('month').format('YYYY-MM-DD')
        newDates[1] = d.endOf('month').format('YYYY-MM-DD')
        this.updateDates(newDates)
       }
       else if(period === 'thismonth')
       {
        const d = moment(todayDate)
        newDates[0] = d.startOf('month').format('YYYY-MM-DD')
        newDates[1] = d.endOf('month').format('YYYY-MM-DD')
        this.updateDates(newDates)
       }
    },
    updateDates(newDates){
     
      this.$set(this.dates,0,newDates[0])
      this.$set(this.dates,1,newDates[1])      
    },
    addDays(date, days) {
      const copy = new Date(date) 
      copy.setDate(date.getDate() + days)
      return copy
    },
    resetDates(){
       this.menu = false
         this.updateDates(this.oldDates)
     },
    saveDates(){

      if(this.dates.length === 1){
        this.dates[1] = this.dates[0]
      }
      if(this.dates.some( (element) => element  === undefined)){
        let idx = this.dates.findIndex( (element) => element  === undefined) 
        if(idx === 0){
          this.dates[0] = this.dates[1]
        }
        else if(idx === 1){
          this.dates[1] = this.dates[0]
        }
      }
      this.$refs.menu.save(this.dates)
      this.loading = true
      this.loadData()
    },
    cancelAutoUpdate(){
      clearInterval(this.timer)
    },
    loadData() {
      console.log('Get for dates', this.dates)
      var self = this
      Promise.all([
        api.getDistribution(self.dates[0], self.dates[1]),
        api.getPaperList(self.dates[0], self.dates[1])
      ])
        .then(([distResp, papersResp]) => {
          console.log(distResp.data)
          console.log(papersResp.data)
          self.list = Array.isArray(distResp.data) ? distResp.data : []
          self.paperEditions = Array.isArray(papersResp.data) ? papersResp.data : []
          self.loading = false
        })
        .catch((err) => {
          self.loading = false
          if (err.response && (err.response.status === 401 || err.response.status === 403)) {
            console.log(err)
            self.$router.push({name:'root'})
          }
          else if (err.response && err.response.status === 404) {
            console.log(err)
          }
        })
    },
    price(papers){
      var tot = 0
      for(var idx= 0; idx < papers.length; idx++){
        var amount = papers[idx].deliveredAmount - papers[idx].receivedAmount
        if(amount < 0){
          amount = -amount
        }
        tot = tot+ (papers[idx].price * amount)
      }
      return tot
    },
    sumPrice(list) {
      var self = this
      return reduce(
        list,
        function(s, cust) {
          return s + self.price(cust.papers)
        },
        0
      )
    },
    sum(list,prop) {      
      return reduce(
        list,
        function(s, cust) {
          return s + cust[prop]
        },
        0
      )
    },
   

    export(customers){  
      for(var idx = 0; idx < customers.length; idx++){
        var price = this.$options.filters.toSek(customers[idx].price)
        customers[idx].price = price
        // var totalPrice = this.$options.filters.toSek(customers[idx].totalPrice)
        // customers[idx].totalPrice = totalPrice
      }
      var result =  process(customers, {
              //group: this.group              
          }).data

          return result
     
    },
     
    exportExcel (dist) {    
      saveExcel({
          data:this.export(this.$options.filters.filterOutPaperByDeliveryDate(dist.exportData, this.filteredDates)),                
          fileName:dist.distributor.name +' ' + this.dateRangeText,
          //group :this.group,
          columns: [
            {field: 'name', title:'Namn',hidden:false },
            {field: 'customerId', title:'Kundnummer',hidden:false },
            {field: 'zipCode', title:'Postnummer',hidden: false },                  
            {field: 'city',title: 'Postort',hidden: false },                
            {field: 'paperName',title: 'Tidning'},
            {field: 'deliveryDate',title: 'Datum', format: '{0: dd-MM-yy}'},
            {field: 'deliveredAmount',title: 'Följesedel'},
            {field: 'receivedAmount',title: 'Mottagit'},
            {field: 'amount', title: 'Antal'},
            {field: 'price',title: 'Pris'},                 
        ]
      })
    },
  },
}
</script>

<style>
.paper{
  font-size: smaller;
}

.zero{
  background-color: #FFC107;
}

.chip{
  font-size: 1rem;
}

</style>
